import { render, staticRenderFns } from "./ExamPaperSelect.vue?vue&type=template&id=6b62ec3c&scoped=true&"
import script from "./ExamPaperSelect.vue?vue&type=script&lang=js&"
export * from "./ExamPaperSelect.vue?vue&type=script&lang=js&"
import style0 from "./ExamPaperSelect.vue?vue&type=style&index=0&id=6b62ec3c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b62ec3c",
  null
  
)

export default component.exports